'use client';

import React from 'react';

import styled from 'styled-components';

/** Portal-owned copy of shared-ui's LoginInput (v0.5.383), verbatim. */

interface Props {
  placeholder: string;
  type: string;
  value: string;
  setValue: (value: string) => void;
}

export const LoginInput: React.FC<Props> = ({ placeholder, type, value, setValue }: Props) => {
  return (
    <StyledLoginInput
      placeholder={placeholder}
      type={type}
      value={value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
      }}
    />
  );
};

const StyledLoginInput = styled.input`
  max-width: 400px;
  width: 100%;
  padding-left: 12px;
  height: 50px;
  margin-bottom: 0;
  font-size: 16px;
  border-radius: 8px;
  color: white;
  border: 1px solid white;
  background-color: transparent;

  &::placeholder {
    color: white;
  }

  @media (min-width: 500px) {
    height: 60px;
  }
`;
